import { render, staticRenderFns } from "./AddBill.vue?vue&type=template&id=84e6cf72&scoped=true"
import script from "./AddBill.vue?vue&type=script&lang=js"
export * from "./AddBill.vue?vue&type=script&lang=js"
import style0 from "./AddBill.vue?vue&type=style&index=0&id=84e6cf72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e6cf72",
  null
  
)

export default component.exports